import { Paper, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { MinimalPageLayout } from '../../components/Navigation/MinimalLayout/MinimalPageLayout';
import { OfferContainer } from '../../components/Offers/OfferContainer';
import { StayInContactIcon } from '../../components/Shared/StayInContactIcon';
import { useGetOfferByKey } from '../../sic-lib/api/hooks/useOrders';
import { OfferTarget } from '../../sic-lib/enums/OfferTarget';

export default function LoginPage() {
    const { classes } = useStyles();

    let { offerKey } = useParams<{ offerKey: string }>();

    const {
        data: offerData,
        isLoading: isOfferLoading,
        isSuccess: isOfferSuccess,
        error: offerError,
    } = useGetOfferByKey(offerKey);

    return (
        <MinimalPageLayout target={offerData?.target}>
            {offerData && offerData.target !== OfferTarget.SIC ? (
                <img className={classes.engage} src="/Success-white-small.webp" alt="Engage Icon" />
            ) : (
                <StayInContactIcon className={classes.icon} />
            )}
            <Paper className={classes.paper}>
                {!offerKey ? (
                    <Typography>Invalid Offer Key</Typography>
                ) : (
                    <OfferContainer
                        isOfferLoading={isOfferLoading}
                        offerData={offerData}
                        isOfferSuccess={isOfferSuccess}
                        offerError={offerError}
                    />
                )}
            </Paper>
        </MinimalPageLayout>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    paper: {
        [theme.breakpoints.up('xs')]: {
            maxWidth: '80%',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: '60%',
        },
    },
    icon: {
        maxWidth: '250px',
        maxHeight: '130px',
    },
    engage: {
        margin: theme.spacing(1),
        maxWidth: '250px',
        maxHeight: '80px',
        borderRadius: 4,
        backgroundColor: 'transparent',
        padding: theme.spacing(1),
    },
}));
